import React, { useEffect, useState } from "react";
import AxiosInstance from "../components/Axios";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  tableCellClasses,
  TableContainer,
  TablePagination,
  Select,
  MenuItem,
  Button,
  IconButton,
  linearProgressClasses,
  LinearProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
import OnlineMetrics from "./OnlineMetrics";
import { styled } from "@mui/material/styles";
import { Input, Progress, Typography } from "antd";
import {
  Edit,
  Delete,
  ArrowDownward,
  CheckOutlined,
  CloseOutlined,
  SaveOutlined,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import axios from "axios";
import colors from "../components/constants/Colors";
import Swal from "sweetalert2";
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 4,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 4,
    backgroundColor: theme.palette.mode === "light" ? "gray" : "#308fe8",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.primary,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Monitoring = () => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [page0, setPage0] = React.useState(0);
  const [rowsPerPage0, setRowsPerPage0] = React.useState(5);

  const [page1, setPage1] = React.useState(0);
  const [rowsPerPage1, setRowsPerPage1] = React.useState(5);

  const [page2, setPage2] = React.useState(0);
  const [rowsPerPage2, setRowsPerPage2] = React.useState(5);

  const [selectedTab, setSelectedTab] = useState("PA");

  const [pagination, setPagination] = useState({
    PA: { page: 0, rowsPerPage: 5 },
    OM: { page: 0, rowsPerPage: 5 },
  });

  const handleTabChange = (event, newTab) => {
    setSelectedTab(newTab);
    setPagination((prev) => ({
      ...prev,
      [newTab]: { page: 0, rowsPerPage: prev[newTab]?.rowsPerPage || 5 },
    }));
  };

  const [loadingSummaryCounts, setLoadingSummaryCounts] = useState(true);

  const [eventTypeCounts, setEventTypeCounts] = useState([]);
  const [loadingEventTypeCounts, setLoadingEventTypeCounts] = useState(true);

  const [socialmediaActivityCounts, setSocialmediaActivityCounts] = useState(
    []
  );
  const [
    loadingSocialmediaActivityCounts,
    setLoadingSocialmediaActivityCounts,
  ] = useState(true);

  const [variables, setVariables] = useState([]);
  const [rpCounts, setRpCounts] = useState([]);

  const [IPRData, setIPRData] = useState([]);
  const [KERData, setKERData] = useState([]);

  const [rows, setRows] = useState([]);
  const [partners, setPartners] = useState([]);

  const [combinedData, setCombinedData] = useState([]);
  const [selectedRP, setSelectedRP] = useState("");
  const [uniqueReportingPeriods, setUniqueReportingPeriods] = useState("");

  const [followersNumber, setFollowersNumber] = useState(0);
  const [showIcons, setShowIcons] = useState(false);
  const project_id = localStorage.getItem("project_id");
  const role = localStorage.getItem("role");
  const is_admin = localStorage.getItem("is_admin");

  const handleInputChange = (id, newValue) => {
    setFollowersNumber((prev) => ({
      ...prev,
      [id]: newValue,
    }));
  };

  const handleFocus = (id) => {
    console.log("Input focused, ID:", id);
    setShowIcons((prev) => ({ ...prev, [id]: true }));
  };

  const handleBlur = (id) => {
    console.log("Input blurred, ID:", id);
    setShowIcons((prev) => ({ ...prev, [id]: false }));
  };

  const updateCurrentCount = async (
    valueId,
    newCount,
    reportingPeriod,
    projectId
  ) => {
    try {
      console.log("coutnesss", valueId, newCount, reportingPeriod, projectId);
      const response = await AxiosInstance.post(
        `update-current-count/${valueId}/`,
        {
          reporting_period: reportingPeriod,
          current_count: newCount,
          project_id: projectId,
        }
      );

      if (response.status === 200) {
        console.log("current count updated successfully for", reportingPeriod);
        Swal.fire(
          "Success",
          "Current count is updated successfully!",
          "success"
        );

        setFollowersNumber(""); // Reset the input field

        // Fetch updated project data
        try {
          const projectResponse = await AxiosInstance.get(
            `projects/${projectId}/variables/`
          );
          const filteredData = projectResponse.data.filter((variable) =>
            variable.values.some(
              (value) => value.reached_counts[projectId] != null
            )
          );
          setVariables(filteredData);
          console.log("Response filtered data:", filteredData);
        } catch (error) {
          console.error("Error fetching project data:", error);
        }
      } else {
        console.error("Failed to update current_count");
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire(
        "Error",
        "Failed to update current count. Please try again later.",
        "error"
      );
    }
  };

  const GetSocialMediaData = async () => {
    return await AxiosInstance.get(`projects/${project_id}/socialmedia/`)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error fetching project data: ", error);
        return [];
      });
  };

  const GetWebData = async () => {
    return await AxiosInstance.get(`projects/${project_id}/websites/`)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error fetching website data: ", error);
        return [];
      });
  };

  const GetEvents = async () => {
    return await AxiosInstance.get(`projects/${project_id}/events/`)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error fetching events data: ", error);
        return [];
      });
  };

  const GetScientifData = async () => {
    return await AxiosInstance.get(`projects/${project_id}/scientifics/`)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error fetching scientific data: ", error);
        return [];
      });
  };

  const GetIPRData = async () => {
    return await AxiosInstance.get(`projects/${project_id}/ipr/`)
      .then((res) => {
        setIPRData(res.data);
        console.log("iPR DATA", res.data);
        return res.data;
      })
      .catch((error) => {
        console.error("Error fetching ipr data: ", error);
        return [];
      });
  };

  const getPartnersInProject = async () => {
    try {
      // Make GET request to fetch partners for the given project
      const response = await AxiosInstance.get(
        `projects/${project_id}/get_partners/`
      );

      if (response.status === 200) {
        // Successfully fetched partners
        const partners = response.data;
        partners(response.data);
        // You can process the partners data here, e.g., update your state or UI
        return partners; // Return the data for further use if needed
      }
    } catch (error) {
      console.error("There was an error fetching partners!", error);
      // Prepare error message
      let errorMessage = "An unexpected error occurred. Please try again.";

      if (error.response && error.response.data) {
        const errorDetails = error.response.data.details || {};
        const formattedErrors = Object.entries(errorDetails)
          .map(([field, messages]) => {
            return messages.map((msg) => `${field}: ${msg}`).join("<br>");
          })
          .join("<br>");

        errorMessage = formattedErrors || errorMessage;
      }
    }
  };

  const GetKERData = async () => {
    return await AxiosInstance.get(`projects/${project_id}/ker/`)
      .then((res) => {
        setKERData(res.data);
        return res.data;
      })
      .catch((error) => {
        console.error("Error fetching ker data: ", error);
        return [];
      });
  };

  const fetchPartners = async () => {
    try {
      const response = await AxiosInstance.get(
        `projects/${project_id}/get_partners/`
      );
      setRows(response.data.map((partner) => ({ id: partner.id, ...partner })));
      console.log("partners contributred ", response.data);

      setPartners(
        response.data.map((partner) => ({ id: partner.id, ...partner }))
      );
    } catch (err) {
      console.log("Failed to fetch partners");
      console.error(err);
    }
  };

  useEffect(() => {
    if (project_id) {
      getPartnersInProject();
    }
    fetchPartners();
  }, []);

  const fetchData = async () => {
    try {
      const [SocialMediaData, websiteData, eventsData, scientificData] =
        await Promise.all([
          GetSocialMediaData(),
          GetWebData(),
          GetEvents(),
          GetScientifData(),
        ]);

      const combinedData = [
        ...SocialMediaData,
        ...websiteData,
        ...eventsData,
        ...scientificData,
      ];

      setCombinedData(combinedData);
      console.log("combined data", combinedData);
    } catch (error) {
      console.error("Error fetching combined data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
    GetIPRData();
    GetKERData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPagination((prev) => ({
      ...prev,
      [selectedTab]: { ...prev[selectedTab], page: newPage },
    }));
    setSelectedRP("");
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setPagination((prev) => ({
      ...prev,
      [selectedTab]: { page: 0, rowsPerPage: newRowsPerPage },
    }));
  };

  const currentPagination = pagination[selectedTab];
  const filteredVariables =
    selectedTab === "OM"
      ? variables.filter((variable) => variable.name === "Followers")
      : variables.filter((variable) => variable.name !== "Followers");

  const handleChangePage0 = (event, newPage) => {
    setPage0(newPage);
    setSelectedRP("");
  };

  const handleChangeRowsPerPage0 = (event) => {
    setRowsPerPage0(+event.target.value);
    setPage0(0);
  };

  const handleChangePage1 = (event, newPage) => {
    setPage1(newPage);
    setSelectedRP("");
  };

  const handleChangeRowsPerPage1 = (event) => {
    setRowsPerPage1(+event.target.value);
    setPage1(0);
  };

  const handleChangePage2 = (event, newPage) => {
    setPage2(newPage);
    setSelectedRP("");
  };

  const handleChangeRowsPerPage2 = (event) => {
    setRowsPerPage2(+event.target.value);
    setPage2(0);
  };

  useEffect(() => {
    AxiosInstance.get("summary-counts/")
      .then((response) => {
        // setSummaryCounts(response.data);
        setLoadingSummaryCounts(false);
      })
      .catch((error) => {
        console.error("Error fetching summary counts:", error);
      });

    AxiosInstance.get("event-type-counts/")
      .then((response) => {
        setEventTypeCounts(response.data);
        setLoadingEventTypeCounts(false);
      })
      .catch((error) => {
        console.error("Error fetching event type counts:", error);
      });

    AxiosInstance.get("socialmedia-activity-counts/").then((response) => {
      setSocialmediaActivityCounts(response.data);
      setLoadingSocialmediaActivityCounts(false);
    });
    AxiosInstance.get(`projects/${project_id}/variables/`)
      .then((response) => {
        console.log("Response not filter:", response);

        const filteredData = response.data.filter((variable) =>
          variable.values.some(
            (value) => value.reached_counts[project_id] != null
          )
        );
        setVariables(filteredData);
        console.log("Response filterdata:", filteredData);
      })
      .catch((error) => console.log(error));
    AxiosInstance.get("get-rp-counts/")
      .then((response) => {
        const data = response.data;

        // Log the response to check its structure
        console.log("Response data:", data);

        // Safeguard against undefined properties
        const eventCounts = Array.isArray(data.event_counts)
          ? data.event_counts
          : [];
        const socialMediaCounts = Array.isArray(data.social_media_counts)
          ? data.social_media_counts
          : [];
        const websiteCounts = Array.isArray(data.website_counts)
          ? data.website_counts
          : [];

        // Extract reporting periods from each count array
        const eventReportingPeriods = eventCounts.map(
          (item) => item.reportingPeriod
        );
        const socialMediaReportingPeriods = socialMediaCounts.map(
          (item) => item.reportingPeriod
        );
        const websiteReportingPeriods = websiteCounts.map(
          (item) => item.reportingPeriod
        );

        // Combine all periods into a single array
        const allReportingPeriods = [
          ...eventReportingPeriods,
          ...socialMediaReportingPeriods,
          ...websiteReportingPeriods,
        ];

        // Create a Set to remove duplicates and convert it back to an array
        const uniqueReportingPeriods = [...new Set(allReportingPeriods)];

        setRpCounts(data);
        console.log("lenght", uniqueReportingPeriods, data);
        setUniqueReportingPeriods(uniqueReportingPeriods);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const getProgressColor = (calculatedValue, reachedCount) => {
    if (reachedCount === 0 || calculatedValue === 0) return "#d9d9d9";
    const percentage = (calculatedValue / reachedCount) * 100;

    if (percentage < 25) return "#ff4d4f";
    if (percentage < 50) return "#ff9800"; // Jaune
    if (percentage < 100) return "#ffec3d"; // Orange
    return "#52c41a";
  };

  console.log("new vars", variables);

  {
    /* Start Modif Audiences count  */
  }
  const getCount = (type, rp) => {
    return combinedData.filter(
      (item) =>
        (item.activity === type ||
          item.status === type ||
          item.type === type ||
          item.audiences.includes(type)) &&
        (rp ? item.reportingPeriod === rp : true)
    ).length;
  };

  const getCountAudiences = (type, rp) => {
    let totalEstimation = 0;
    combinedData.forEach((item) => {
      if (item.audiences.includes(type) && item.estimation) {
        if (rp ? item.reportingPeriod === rp : true) {
          totalEstimation += parseInt(item.estimation, 10);
        }
      }
    });

    return totalEstimation;
  };
  {
    /* End Modif Audiences count  */
  }

  const getCountByRP = (type, rp) => {
    return combinedData.filter(
      (item) =>
        (item.activity === type && item.reportingPeriod === rp) ||
        (item.status === type && item.reportingPeriod === rp) ||
        (item.type === type && item.reportingPeriod === rp) ||
        (item.audience === type && item.reportingPeriod === rp) ||
        (item.reportingPeriod === type && item.reportingPeriod === rp)
    ).length;
  };

  console.log("combined data", combinedData);

  const handleRPChange = (rowIndex, event) => {
    setSelectedRP((prev) => ({ ...prev, [rowIndex]: event.target.value }));
  };

  /* Start Funcitons for following modification  */
  const calculateValue = (
    variable,
    value,
    project_id,
    selectedRP,
    rowIndex
  ) => {
    if (variable.name === "Followers") {
      console.log("currenteee1", variable, selectedRP, rowIndex, value);

      const projectCounts = value.current_count?.[project_id];
      console.log("currenteee", value);
      if (!projectCounts) return 0;

      if (selectedRP[rowIndex] === "All" || !selectedRP[rowIndex]) {
        console.log("helloooooo");
        // if  "All": Somme all reporting periods
        return Object.values(projectCounts).reduce(
          (sum, count) => sum + Number(count),
          0
        );
      }

      return projectCounts[selectedRP[rowIndex]] || 0;
    }

    return variable.name === "Audiences"
      ? getCountAudiences(value.name, selectedRP[rowIndex])
      : getCount(value.name, selectedRP[rowIndex]);
  };
  const getProgressProps = (
    variable,
    value,
    project_id,
    selectedRP,
    rowIndex
  ) => {
    const calculatedValue = calculateValue(
      variable,
      value,
      project_id,
      selectedRP,
      rowIndex
    );
    const reachedCount = value.reached_counts?.[project_id] || 0; // Utiliser reachedCount ou 0 si inexistant

    return {
      strokeColor: getProgressColor(calculatedValue, reachedCount),
      percent: reachedCount > 0 ? (calculatedValue / reachedCount) * 100 : 0,
      size: "small",
      format: () => (
        <p>
          {calculatedValue} / {reachedCount} {value.name}
        </p>
      ),
    };
  };

  const renderFollowersInput = (
    value,
    project_id,
    selectedRP,
    rowIndex,
    role,
    followersNumber,
    handleInputChange,
    handleFocus,
    handleBlur,
    updateCurrentCount
  ) => {
    const calculatedValue = calculateValue(
      { name: "Followers" },
      value,
      project_id,
      selectedRP,
      rowIndex
    );

    if (role === "none" || role === "coordinator" || role === "moderator") {
      return (
        <div style={{ display: "flex" }}>
          <Input
            disabled={!selectedRP[rowIndex]}
            key={value.id}
            style={{ width: 50, marginTop: -5 }}
            value={followersNumber[value.id] ?? calculatedValue}
            onChange={(e) => handleInputChange(value.id, e.target.value)}
            onFocus={() => handleFocus(value.id)}
            onBlur={() => handleBlur(value.id)}
          />
          <SaveOutlined
            style={{
              color: colors.primary,
              marginLeft: 20,
              cursor: "pointer",
              fontSize: 30,
            }}
            onClick={() => {
              if (selectedRP[rowIndex]) {
                updateCurrentCount(
                  value.id,
                  followersNumber[value.id],
                  selectedRP[rowIndex],
                  project_id
                );
              } else {
                console.warn("Reporting period not selected");
                Swal.fire(
                  "Error",
                  "Reporting period is not selected.",
                  "error"
                );
              }
            }}
          />
        </div>
      );
    }

    return <p>{followersNumber[value.id] ?? calculatedValue}</p>;
  };
  /* End Funcitons for following modification  */

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TableContainer sx={{ width: "100%" }} component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell style={{ width: 280 }}></StyledTableCell>
                  <StyledTableCell>Level of Entrance</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {partners
                  .slice()
                  .sort((a, b) => {
                    const levelA = a.levels?.[project_id.toString()] ?? 0;
                    const levelB = b.levels?.[project_id.toString()] ?? 0;
                    return levelB - levelA;
                  })
                  .slice(
                    page0 * rowsPerPage0,
                    page0 * rowsPerPage0 + rowsPerPage0
                  )
                  .map((partner) => (
                    <StyledTableRow key={partner.id}>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <span
                          style={{
                            textAlign: "left",
                            flex: 0.2,
                            fontWeight: "500",
                            marginRight: 5,
                          }}
                        >
                          {partner.name}
                        </span>
                        {partner.imageURL != null ? (
                          <img
                            src={partner.imageURL}
                            alt="logo"
                            style={{
                              width: "100%",
                              height: "auto",
                              maxWidth: "80px",
                              maxHeight: "50px",
                              objectFit: "contain",
                              marginTop: 0,
                              flexShrink: 0,
                            }}
                          />
                        ) : (
                          "N/A"
                        )}
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        {" "}
                        {partner.levels &&
                        partner.levels[project_id.toString()] !== undefined
                          ? partner.levels[project_id.toString()]
                          : 0}{" "}
                        <Progress
                          percent={
                            partner.levels &&
                            partner.levels[project_id.toString()] !== undefined
                              ? partner.levels[project_id.toString()]
                              : 0
                          }
                          strokeColor="gray"
                          size="default"
                          showInfo={false}
                        />
                        {/* <BorderLinearProgress
                          variant="determinate"
                          value={
                            partner.levels &&
                            partner.levels[project_id.toString()] !== undefined
                              ? partner.levels[project_id.toString()]
                              : 0
                          }
                        /> */}{" "}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={partners.length}
            rowsPerPage={rowsPerPage0}
            page={page0}
            onPageChange={handleChangePage0}
            onRowsPerPageChange={handleChangeRowsPerPage0}
          />
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={selectedTab} onChange={handleTabChange}>
              <Tab label="Progress achievement" value="PA" />
              <Tab label="Online Metrics" value="OM" />
            </Tabs>
          </Box>
          {selectedTab != "OM" ? (
            <div>
              <TableContainer sx={{ width: "100%" }} component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Category</StyledTableCell>
                      <StyledTableCell>Type</StyledTableCell>
                      <StyledTableCell align="left">
                        Reporting Period
                      </StyledTableCell>
                      <StyledTableCell align="left" style={{ width: 200 }}>
                        Number
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        Objective (reached count)
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {variables
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .slice(
                        pagination[selectedTab].page *
                          pagination[selectedTab].rowsPerPage,
                        pagination[selectedTab].page *
                          pagination[selectedTab].rowsPerPage +
                          pagination[selectedTab].rowsPerPage
                      )
                      .flatMap((variable, rowIndex) =>
                        variable.values.map((value, valueIndex) => (
                          <StyledTableRow key={value.id}>
                            <StyledTableCell component="th" scope="row">
                              {variable.name}
                            </StyledTableCell>
                            <StyledTableCell>{value.name}</StyledTableCell>
                            {/* Start modif RP sorting */}
                            <StyledTableCell align="left">
                              <Select
                                value={selectedRP[rowIndex] || ""}
                                onChange={(event) =>
                                  handleRPChange(rowIndex, event)
                                }
                                displayEmpty
                              >
                                <MenuItem value="">All</MenuItem>
                                {uniqueReportingPeriods.length > 0 ? (
                                  [...uniqueReportingPeriods]
                                    .sort((a, b) => a.localeCompare(b))
                                    .map((rp) => (
                                      <MenuItem key={rp} value={rp}>
                                        {rp.toUpperCase()}
                                      </MenuItem>
                                    ))
                                ) : (
                                  <MenuItem value="" disabled>
                                    No Reporting Periods Available
                                  </MenuItem>
                                )}
                              </Select>
                            </StyledTableCell>
                            {/* End modif RP sorting */}

                            <StyledTableCell align="left">
                              {variable.name === "Followers"
                                ? renderFollowersInput(
                                    value,
                                    project_id,
                                    selectedRP,
                                    rowIndex,
                                    role,
                                    followersNumber,
                                    handleInputChange,
                                    handleFocus,
                                    handleBlur,
                                    updateCurrentCount
                                  )
                                : calculateValue(
                                    variable,
                                    value,
                                    project_id,
                                    selectedRP,
                                    rowIndex
                                  )}
                            </StyledTableCell>

                            <StyledTableCell align="center">
                              <Progress
                                {...getProgressProps(
                                  variable,
                                  value,
                                  project_id,
                                  selectedRP,
                                  rowIndex
                                )}
                              />
                            </StyledTableCell>
                            {/* End Modif Audiences count  */}
                          </StyledTableRow>
                        ))
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={variables.length}
                rowsPerPage={pagination[selectedTab].rowsPerPage}
                page={pagination[selectedTab].page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          ) : (
            // Appel de la component OnlineMetrics pour la deuxieme Tab
            <OnlineMetrics />
          )}
        </Grid>
        {/*  <Grid item xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={selectedTab} onChange={handleTabChange}>
              <Tab label="Progress achievement" value="PA" />
              <Tab label="Online Metrics" value="OM" />
            </Tabs>
          </Box>

          <TableContainer sx={{ width: "100%" }} component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Category</StyledTableCell>
                  <StyledTableCell>Type</StyledTableCell>
                  <StyledTableCell align="left">
                    Reporting Period
                  </StyledTableCell>
                  <StyledTableCell align="left" style={{ width: 200 }}>
                    Number
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    Objective (reached count)
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {variables
                  // Appliquer un filtre basé sur l'onglet sélectionné
                  .filter((variable) =>
                    selectedTab === "OM"
                      ? variable.name === "Followers"
                      : variable.name !== "Followers"
                  )
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .slice(
                    pagination[selectedTab].page *
                      pagination[selectedTab].rowsPerPage,
                    pagination[selectedTab].page *
                      pagination[selectedTab].rowsPerPage +
                      pagination[selectedTab].rowsPerPage
                  )
                  .flatMap((variable, rowIndex) =>
                    variable.values.map((value, valueIndex) => (
                      <StyledTableRow key={value.id}>
                        <StyledTableCell component="th" scope="row">
                          {variable.name}
                        </StyledTableCell>
                        <StyledTableCell>{value.name}</StyledTableCell>
                        <StyledTableCell align="left">
                          <Select
                            value={selectedRP[rowIndex] || ""}
                            onChange={(event) =>
                              handleRPChange(rowIndex, event)
                            }
                            displayEmpty
                          >
                            <MenuItem value="">All</MenuItem>
                            {uniqueReportingPeriods.length > 0 ? (
                              [...uniqueReportingPeriods]
                                .sort((a, b) => a.localeCompare(b))
                                .map((rp) => (
                                  <MenuItem key={rp} value={rp}>
                                    {rp.toUpperCase()}
                                  </MenuItem>
                                ))
                            ) : (
                              <MenuItem value="" disabled>
                                No Reporting Periods Available
                              </MenuItem>
                            )}
                          </Select>
                        </StyledTableCell>

                        <StyledTableCell align="left">
                          {variable.name === "Followers"
                            ? renderFollowersInput(
                                value,
                                project_id,
                                selectedRP,
                                rowIndex,
                                role,
                                followersNumber,
                                handleInputChange,
                                handleFocus,
                                handleBlur,
                                updateCurrentCount
                              )
                            : calculateValue(
                                variable,
                                value,
                                project_id,
                                selectedRP,
                                rowIndex
                              )}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <Progress
                            {...getProgressProps(
                              variable,
                              value,
                              project_id,
                              selectedRP,
                              rowIndex
                            )}
                          />
                        </StyledTableCell>

                    
                      </StyledTableRow>
                    ))
                  )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={
              variables.filter((variable) =>
                selectedTab === "OM"
                  ? variable.name === "Followers"
                  : variable.name !== "Followers"
              ).length
            }
            rowsPerPage={pagination[selectedTab].rowsPerPage}
            page={pagination[selectedTab].page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid> */}
        <br />
        <br />

        {role === "none" || role === "coordinator" || role === "moderator" ? (
          <Grid>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginBottom: 0,
              }}
            >
              <h2 style={{ color: colors.secondary }}>IPR Table</h2>
              <Button
                href="/create_ipr"
                variant="contained"
                sx={{
                  height: 30,
                  marginTop: 5,
                  borderRadius: 2,
                  backgroundColor: colors.primary,
                }}
              >
                Add new ipr{" "}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <TableContainer sx={{ width: "100%" }} component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell style={{ width: 120 }}></StyledTableCell>
                      <StyledTableCell>Type of IP Rights</StyledTableCell>
                      <StyledTableCell>Application title</StyledTableCell>
                      <StyledTableCell align="left">
                        Application reference
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        Application Date
                      </StyledTableCell>
                      <StyledTableCell align="left">IPR Owner</StyledTableCell>
                      <StyledTableCell align="left">IPR Status</StyledTableCell>
                      <StyledTableCell align="left">
                        IPR Award Reference
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {IPRData.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    ).map((ipr) => (
                      <StyledTableRow key={ipr.id}>
                        <StyledTableCell>
                          <Grid container>
                            <IconButton
                              component={Link}
                              to={`edit_ipr/${ipr.id}`}
                              state={{ iprData: ipr }}
                            >
                              <Edit color="primary" />
                            </IconButton>
                            <IconButton
                              color="error"
                              component={Link}
                              to={`delete_ipr/${ipr.id}`}
                            >
                              <Delete color="error" />
                            </IconButton>
                          </Grid>
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {ipr.type_ipr}
                        </StyledTableCell>
                        <StyledTableCell>
                          {ipr.application_title}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ipr.application_reference}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ipr.application_date}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ipr.ipr_owner_details
                            .map((owner) => `${owner.name}`)
                            .join(", ")}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ipr.ipr_status}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ipr.award_reference}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={IPRData.length}
                rowsPerPage={rowsPerPage2}
                page={page2}
                onPageChange={handleChangePage2}
                onRowsPerPageChange={handleChangeRowsPerPage2}
              />
            </Grid>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginBottom: 0,
              }}
            >
              <h2 style={{ color: colors.secondary }}>KER Table</h2>
              <Button
                href="/create_ker"
                variant="contained"
                sx={{
                  height: 30,
                  marginTop: 5,
                  borderRadius: 2,
                  backgroundColor: colors.primary,
                }}
              >
                Add new{" "}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <TableContainer sx={{ width: "100%" }} component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell style={{ width: 120 }}></StyledTableCell>
                      <StyledTableCell>Number of KER</StyledTableCell>
                      <StyledTableCell>Type of KER</StyledTableCell>
                      <StyledTableCell align="left">
                        Description
                      </StyledTableCell>
                      <StyledTableCell align="left">Start TRL</StyledTableCell>
                      <StyledTableCell align="left">End TRL</StyledTableCell>
                      <StyledTableCell align="left">Ownership</StyledTableCell>
                      <StyledTableCell align="left">
                        Type of exploitation
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {KERData.slice(
                      page1 * rowsPerPage1,
                      page1 * rowsPerPage1 + rowsPerPage1
                    ).map((ker) => (
                      <StyledTableRow key={ker.id}>
                        <StyledTableCell>
                          <Grid container>
                            <IconButton
                              component={Link}
                              to={`edit_ker/${ker.id}`}
                              state={{ kerData: ker }}
                            >
                              <Edit color="primary" />
                            </IconButton>
                            <IconButton
                              color="error"
                              component={Link}
                              to={`delete_ker/${ker.id}`}
                            >
                              <Delete color="error" />
                            </IconButton>
                          </Grid>
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {" "}
                          {ker.number_ker}{" "}
                        </StyledTableCell>
                        <StyledTableCell>{ker.type_ker}</StyledTableCell>
                        <StyledTableCell align="left">
                          {ker.description}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ker.start}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ker.end}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ker.ownership_details
                            .map((owner) => `${owner.name}`)
                            .join(", ")}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ker.type_exploitation}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={KERData.length}
                rowsPerPage={rowsPerPage1}
                page={page1}
                onPageChange={handleChangePage1}
                onRowsPerPageChange={handleChangeRowsPerPage1}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid>
            <Grid item xs={12}>
              <TableContainer sx={{ width: "100%" }} component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell style={{ width: 120 }}></StyledTableCell>
                      <StyledTableCell>Type of IP Rights</StyledTableCell>
                      <StyledTableCell>Application title</StyledTableCell>
                      <StyledTableCell align="left">
                        Application reference
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        Application Date
                      </StyledTableCell>
                      <StyledTableCell align="left">IPR Owner</StyledTableCell>
                      <StyledTableCell align="left">IPR Status</StyledTableCell>
                      <StyledTableCell align="left">
                        IPR Award Reference
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {IPRData.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    ).map((ipr) => (
                      <StyledTableRow key={ipr.id}>
                        <StyledTableCell>
                          {/* <Grid container>
                            <IconButton
                              component={Link}
                              to={`edit_ipr/${ipr.id}`}
                            >
                              <Edit color="primary" />
                            </IconButton>
                            <IconButton
                              color="error"
                              component={Link}
                              to={`delete_ipr/${ipr.id}`}
                            >
                              <Delete color="error" />
                            </IconButton>
                          </Grid> */}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {ipr.type_ipr}
                        </StyledTableCell>
                        <StyledTableCell>
                          {ipr.application_title}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ipr.application_reference}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ipr.application_date}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ipr.ipr_owner_details
                            .map((owner) => `${owner.name}`)
                            .join(", ")}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ipr.ipr_status}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ipr.award_reference}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={IPRData.length}
                rowsPerPage={rowsPerPage2}
                page={page2}
                onPageChange={handleChangePage2}
                onRowsPerPageChange={handleChangeRowsPerPage2}
              />
            </Grid>
            {/* <Grid sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: 0 }}>
            <h2 style={{ color: colors.secondary }}>KER Table</h2>
            <Button href="/create_ker" variant="contained" sx={{ height: 30, marginTop: 5, borderRadius: 2, backgroundColor: colors.primary }}>Add new  </Button>
          </Grid> */}
            <Grid item xs={12}>
              <TableContainer sx={{ width: "100%" }} component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell style={{ width: 120 }}></StyledTableCell>
                      <StyledTableCell>Number of KER</StyledTableCell>
                      <StyledTableCell>Type of KER</StyledTableCell>
                      <StyledTableCell align="left">
                        Description
                      </StyledTableCell>
                      <StyledTableCell align="left">Start TRL</StyledTableCell>
                      <StyledTableCell align="left">End TRL</StyledTableCell>
                      <StyledTableCell align="left">Ownership</StyledTableCell>
                      <StyledTableCell align="left">
                        Type of exploitation
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {KERData.slice(
                      page1 * rowsPerPage1,
                      page1 * rowsPerPage1 + rowsPerPage1
                    ).map((ker) => (
                      <StyledTableRow key={ker.id}>
                        <StyledTableCell>
                          {/* <Grid container>
                          <IconButton component={Link} to={`edit_ker/${ker.id}`}>
                            <Edit color='primary' />
                          </IconButton>
                          <IconButton color="error" component={Link} to={`delete_ker/${ker.id}`}>
                            <Delete color='error' />
                          </IconButton>
                        </Grid> */}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {" "}
                          {ker.number_ker}{" "}
                        </StyledTableCell>
                        <StyledTableCell>{ker.type_ker}</StyledTableCell>
                        <StyledTableCell align="left">
                          {ker.description}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ker.start_trl}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ker.end_trl}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ker.ownership_details
                            .map((owner) => `${owner.name}`)
                            .join(", ")}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {ker.type_exploitation}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={KERData.length}
                rowsPerPage={rowsPerPage1}
                page={page1}
                onPageChange={handleChangePage1}
                onRowsPerPageChange={handleChangeRowsPerPage1}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      <br />
    </div>
  );
};

export default Monitoring;
